import React from 'react'
import { antColors as colors } from '@frontend/constants/colors'


export const Title = ({level, style={}, children, type="default"}) => {
    
    const styles = {    
        marginBottom: "0.5em",
        fontWeight: 600,
    }

    const getTitle = (level, children) => {
        let result = null
        let newStyles = {color: colors[type], ...styles, ...style}

        switch(level) {
            case 1: 
                result = <h1 style={{...newStyles, fontSize: 38}}>{children}</h1>
                break;
            case 2: 
                result = <h2 style={{...newStyles, fontSize: 32}}>{children}</h2>
                break;
            case 3: 
                result = <h3 style={{...newStyles, fontSize: 24}}>{children}</h3>
                break;
            case 4: 
                result = <h4 style={{...newStyles, fontSize: 18}}>{children}</h4>
                break;
            default:
                result = <h5 style={{...newStyles, fontSize: 15}}>{children}</h5>
                break;
                
        }

        return result
    }
    return (
        getTitle(level,children)
    )
}

